import { WarningTwoIcon, CheckCircleIcon } from "@chakra-ui/icons";


export const IconWarningOrOkay = ({ isOk = false }) => { 
  if (isOk) {
    return <CheckCircleIcon color="green.500" />
  } 
  
  return <WarningTwoIcon color="orange.500" />
}